export default {
  sm: `
     데이터센터 곳곳의 고중량 서버 장비를 운송합니다. 최대 400kg까지 적재가 가능하고, 창고와 서버실 사이를 이동하며 장비 입고·반입 작업을 안전하게 수행합니다.
  `,
  xl: `
    데이터센터 곳곳의 고중량 서버 장비를 운송합니다.
    최대 400kg까지 적재가 가능하고, 창고와 서버실 사이를
    이동하며 장비 입고·반입 작업을 안전하게 수행합니다.
  `,
};
